import { Button, Flex, Modal, Text } from "@mantine/core";

import { DocumentInfo } from "./DocumentInfo/DocumentInfo.tsx";
import { DocumentType } from "./types.ts";

interface Props {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  documentType?: DocumentType;
  documentName?: string;
  loading: boolean;
}

const DocumentUploadConfirmationDialog = ({
  opened,
  onClose,
  onConfirm,
  documentType,
  documentName,
  loading,
}: Props) => {
  return (
    <Modal
      opened={opened}
      title="Are you sure you want to submit this document for IDP & FD?"
      size="md"
      withCloseButton={false}
      closeOnClickOutside={false}
      onClose={onClose}
    >
      <Flex direction="column" gap={20}>
        <DocumentInfo>
          <Text>
            Document type: <strong>{documentType}</strong>
          </Text>
          <Text>
            Document Name: <strong>{documentName}</strong>
          </Text>
        </DocumentInfo>
        <Flex gap={20} justify="end">
          <Button
            variant="outlineBlue"
            uppercase
            type="reset"
            onClick={onClose}
          >
            cancel
          </Button>
          <Button
            variant="filledBlue"
            uppercase
            type="submit"
            disabled={loading}
            loading={loading}
            onClick={onConfirm}
          >
            submit
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

export default DocumentUploadConfirmationDialog;
